import React, {Component, useEffect} from 'react'
import { Link } from 'react-router-dom'
import QuestionDetail from "./QuestionDetail";
import QuestionList from "./QuestionList";
import QuestionWriteTerms from "./QuestionWriteTerms";
import history from "../../route/history";
import {questionActions} from "../../store/actions";
import {connect} from "react-redux";
import QuestionPwdPopup from "./QuestionPwdPopup";

const Question = props => {

  const prePage = (e) => {
    e.preventDefault();
    window.history.back()
  }
    return(
      <React.Fragment>
        <main>
          {props.isShowPwdPopup === true &&
            <QuestionPwdPopup search={props.location?.search} onClick={() => {}}/>
          }
          {/* {props?.isShowTerms === true &&
          <QuestionWriteTerms />
          } */}

        <div id="contents">
          <div className='content-header'>
            <a onClick={prePage} className="page-prev">뒤로이동</a> {/* mobile */}
            <h2>문의하기</h2>
            <div className="breadcrumb">
              <span>Home</span><span>고객센터</span><em>문의하기</em>
            </div>
          </div>

          <div className="notice-tab">
            <ul className='nav-tab mt40'>
                <li><Link title="공지사항" to="/notice">공지사항</Link></li>
                <li><Link title="FAQ" to="/faq">FAQ</Link></li>
                <li className="on"><Link title="문의하기" to="/question">문의하기</Link></li>
                <li><Link title="자료실" to="/reference">자료실</Link></li>
                <li><Link title="이용안내" to="/guide">이용안내</Link></li>
            </ul> 
          </div>
                {
                    props.match.params.seq ?
                        <QuestionDetail seq={props.match.params.seq} searchInfo={props.location.state}/>
                        : <QuestionList search={props.location?.search}/>
                }

          </div>
        </main>
      </React.Fragment>
    )

}

const mapStateToProps = state => {
    return {
        isShowTerms : state.quest.showTerms,
        isShowPwdPopup : state.quest.showPwdPopup,
    }
}
const actionCreators = {
    showTerms: questionActions.showTerms,
    showPwdPopup: questionActions.showPwdPopup,
}
export default connect(
    mapStateToProps,
    actionCreators
)(Question)